import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Seagrass from '../../components/Seagrass/Seagrass';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardSeagrass extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Seagrass/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Shallow Coastal Waters"
   diagnosis="The root systems of seagrass beds secure soft sediments, preventing it from being washed onto coral reefs, and providing some protection to coasts and coastal communities from strong ocean storms."
   prediction="As Seagrass meadows degrade, fewer juvenile fish will make it to maturity, and the impacts of storm surge on coastal cities could be amplified (Oceana)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardSeagrass;
